<template>
  <div>
    <!-- 补买订单审核 -->
    <baseBreadcrumb :menu="$t('message.money')" :page="$t('message.replenishmentOrder')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <div class="item" v-for="(it, index) in tab" :key="index" @click="searchTabs(it.status)"
          :class="{ 'active': it.status === datas.status }">
          <span>{{ it.label }} {{ index === 0 ? '' : '(' + it.count + ')' }}</span>
        </div>
      </div>
      <!-- 搜索 -->
      <div class="search">
        <!-- 交易号 -->
        <div class="item">
          <el-input v-model="datas.purchase_no" :placeholder="$t('message.replenishmentTransactionNumber')"
            clearable></el-input>
        </div>
        <!-- 订单号 -->
        <div class="item">
          <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable></el-input>
        </div>
        <!-- 客户ID -->
        <div class="item">
          <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" clearable></el-input>
        </div>
        <!-- 采购 -->
        <div class="item">
          <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
            <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 业务 -->
        <div class="item">
          <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
            <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 配货员 -->
        <div class="item">
          <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
            <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!--搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        <!-- 补买登记 -->
        <div class="add">
          <el-button type="success" @click="add" v-if="isAuth(681)">{{ $t('message.replenishmentRegistration')
          }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <!-- 订单号 -->
          <li class="flex15">{{ $t('message.orderNumber') }}</li>
          <!-- 番号 -->
          <li class="flex05">{{ $t('message.mash') }}</li>
          <!-- 客户信息 -->
          <li>{{ $t('message.userInfo') }}</li>
          <!-- 登记信息 -->
          <li>{{ $t('message.registrationInformation') }}</li>
          <!-- 补买交易号 -->
          <li>{{ $t('message.replenishmentTransactionNumber') }}</li>
          <!-- 合计补买金额（CNY） -->
          <li>{{ $t('message.totalReplenishmentAmountInCNY') }}</li>
          <!-- 详细说明 -->
          <li>{{ $t('message.detailedExplanation') }}</li>
          <!-- 沟通截图 -->
          <li class="flex15">{{ $t('message.communicationScreensho') }}</li>
          <!-- 是否内部赔款/赔款单号 -->
          <li>{{ $t('message.isInternalClaimOrClaimNumber') }}</li>
          <!-- 财务审核备注 -->
          <li class="flex15" v-if="isAuth(711)">{{ $t('message.financialAuditRemarks') }}</li>
          <!-- 审核状态 -->
          <li class="flex05">{{ $t('message.auditStatus') }}</li>
          <!-- 操作 -->
          <li class="operation">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <!-- 订单号 -->
          <li class="flex15">
            <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">{{
              item.order_sn }}</router-link>
          </li>
          <!-- 番号 -->
          <li class="flex05">
            <p> <span v-for="i in item.sorting" :key="i">{{ i }},</span></p>
          </li>
          <!-- 客户信息 -->
          <li>
            <div class="template">
              <!-- 客户名 -->
              <div class="item">
                <span>{{ $t('message.userName') }}:</span>
                <span>{{ item.order.user.realname }}</span>
              </div>
              <div class="item">
                <span>ID:</span>
                <span>{{ item.order.user.id }}</span>
              </div>
              <div class="item">
                <attributeName :name="item.user_attribute.name" />
              </div>
            </div>
          </li>
          <!-- 登记信息 -->
          <li>
            <div class="template">
              <!-- 登记人 -->
              <div class="item">
                <span>{{ $t('message.personOfRegistration') }}:</span>
                <span>{{ item.created_by_admin.realname }}</span>
              </div>
              <!-- 登记时间 -->
              <div class="item">
                <span>{{ $t('message.registrationTime') }}:</span>
                <span>{{ item.created_at }}</span>
              </div>
            </div>
          </li>
          <!-- 补买交易号 -->
          <li>
            <p>{{ item.purchase_no }}</p>
          </li>
          <!-- 合计补买金额（CNY） -->
          <li>{{ item.amount }}</li>
          <!-- 详细说明 -->
          <li>{{ item.desc }}</li>
          <!-- 沟通截图 -->
          <li class="flex15">
            <div class="template">
              <el-image :src="img" fit="fill" :preview-src-list="[img]" class="image-preview"
                v-for="(img, index) in item.images" :key="index" />
            </div>
          </li>
          <!-- 是否内部赔款/赔款单号 -->
          <li>
            <p>
              <el-link type="primary" size="mini" :href="'/#/reparationList?reparation_sn=' + item.reparation_sn"
                target="_blank">{{ item.reparation_sn }}</el-link>
            </p>
          </li>
          <!-- 财务审核备注 -->
          <li class="flex15" v-if="isAuth(711)">
            <el-input v-model="item.audit_remark" placeholder="请输入财务审核备注" type="textarea"
              @blur="purchaseAddUpdateRemark(item)"></el-input>
          </li>
          <!-- 审核状态 -->
          <li class="flex05">{{ item.status_text }}</li>
          <!-- 操作 -->
          <li class="operation">
            <div class="template" v-if="item.status == 0">
              <!--信息补充  -->
              <p v-if="isAuth(681)">
                <el-button type="success" size="mini" @click="informationSupplementation(item)">
                  {{ $t('message.informationSupplementation') }}
                </el-button>
              </p>
              <!-- 审核 -->
              <p v-if="isAuth(674)">
                <el-button type="primary" size="mini" @click="audit(item)">{{ $t('message.audit') }}</el-button>
              </p>
              <!--删除补买登记  -->
              <p v-if="isAuth(682)">
                <el-button type="danger" size="mini" @click="purchaseAddDelete(item.id)">{{ $t('message.delete')
                }}</el-button>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 审核弹窗 -->
    <el-dialog title="审核" :visible.sync="dialogVisible" width="450px">
      <div class="dialog-content">
        <!-- 财务审核备注 -->
        <el-input v-model="auditData.audit_remark" :placeholder="$t('message.financialAuditRemarks')"
          type="textarea"></el-input>
      </div>
      <template slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAudit">{{ $t('message.submit') }}</el-button>
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      </template>
    </el-dialog>
    <!-- 补买登记弹窗 -->
    <replenishmentRegistration ref="replenishmentRegistration" />
  </div>
</template>
<script>
import replenishmentRegistration from './components/replenishmentRegistration.vue'
export default {
  components: {
    replenishmentRegistration,
  },
  data() {
    return {
      // 审核弹窗
      dialogVisible: false,
      // 审核数据
      auditData: {},
      tab: [],
      datas: {
        status: '',
        purchase_no: '',
        order_sn: '',
        user_id: '',
        y_id: '',
        g_id: '',
        p_id: '',
        page: 1,
        pageSize: 10,

      },
      total: 0,
      tableData: []
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.purchaseAddListTab()
    this.purchaseAddList()
  },

  methods: {
    // 列表tab统计
    purchaseAddListTab() {
      this.$api.financialApi.purchaseAddListTab().then(res => {
        this.tab = res.data
      })
    },
    // 列表
    purchaseAddList() {
      this.$api.financialApi.purchaseAddList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(this.tableData);
      })
    },
    // 搜索tab
    searchTabs(key) {
      this.datas.status = key
      this.search()
    },
    // 搜索
    search() {
      this.datas.page = 1
      this.purchaseAddList()
    },
    // 重置
    reset() {
      this.datas = {
        status: '',
        purchase_no: '',
        order_sn: '',
        user_id: '',
        y_id: '',
        g_id: '',
        p_id: '',
        page: 1,
        pageSize: 10,
      }
      this.search()
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.purchaseAddList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.purchaseAddList();
    },
    // 更新财务审核备注
    purchaseAddUpdateRemark(item) {
      let datas = {
        id: item.id,
        audit_remark: item.audit_remark,
      }
      this.$api.financialApi.purchaseAddUpdateRemark(datas)
    },
    // 审核
    audit(item) {
      this.auditData = {
        id: item.id,
        audit_remark: item.audit_remark,
      }
      this.dialogVisible = true
    },
    // 提交审核
    submitAudit() {
      let datas = {
        id: this.auditData.id,
        audit_remark: this.auditData.audit_remark,
      }
      this.$api.financialApi.purchaseAddAudit(datas).then(res => {
        this.$message({
          message: res.msg,
          type: 'success',
        })
        this.dialogVisible = false
        this.search()
      })
    },
    // 补买登记
    add() {
      this.$refs.replenishmentRegistration.datas = {
        order_sn: '',
        order_detail_id: [],
        purchase_no: '',
        amount: '',
        reason: '',
        desc: '',
        images: [],
        is_reparation: 0,
        reparation_sn: '',
        origin_purchase_nos: [],
      }
      this.$refs.replenishmentRegistration.dialogVisible = true
      this.$refs.replenishmentRegistration.isAdd = true
      this.$refs.replenishmentRegistration.orderDetail = []
      this.$refs.replenishmentRegistration.title = this.$t('message.replenishmentRegistration')
    },
    // 信息补充
    informationSupplementation(item) {
      this.$refs.replenishmentRegistration.datas = JSON.parse(JSON.stringify(item))
      this.$refs.replenishmentRegistration.dialogVisible = true
      this.$refs.replenishmentRegistration.isAdd = false
      this.$refs.replenishmentRegistration.title = this.$t('message.informationSupplementation')
      this.$refs.replenishmentRegistration.getOriginPurchaseNoOptions()
      // this.$refs.replenishmentRegistration.purchaseAddGetOrderDetailOptions()
    },
    // 删除补买登记
    purchaseAddDelete(id) {
      this.$confirm(this.$t('message.areYouSureToDelete'), this.$t('message.prompt'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
      }).then(() => {
        this.$api.financialApi.purchaseAddDelete({ id }).then(res => {
          this.$message({
            message: res.msg,
            type: 'success',
          })
          this.purchaseAddList()
        })
      }).catch(() => {

      });
    }

  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;
  position: relative;
  margin: 0 0px 24px;

  .applyForDepositWithdrawalModification {
    position: absolute;
    top: 0;
    right: 0;
  }

  .item {
    width: 200px;
    margin-right: 12px;
  }

  // 补买登记
  .add {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.tabs {
  display: flex;
  margin-bottom: 24px;

  .item {
    border: 1px solid #e4e7ed;
    padding: 10px 20px;
    cursor: pointer;

    &.active {
      background-color: #B4272D;
      color: #fff;
      border-color: #B4272D;
    }
  }
}

.table {

  ol {
    height: 60px;
    text-align: center;
  }

  ul {
    background-color: #fff;
    padding: 20px 0;
    text-align: center;


  }

  .operation {
    z-index: 10;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .template {
    p {
      margin-bottom: 10px;

      &:nth-last-child(1) {
        margin: 0;
      }
    }

    .el-image {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }
}

/deep/.el-textarea__inner {
  height: 100px;
  resize: none;
  padding: 5px;
}
</style>